import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './LandingHero.css';
import PaymentBadges from './PaymentBadges';

const LandingHero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger animations after component mounts
    setIsLoaded(true);
  }, []);
  // Array of images for the scrolling gallery
  const images = [
    '/images/Hero_Images/1.jpg',
    '/images/Hero_Images/2.jpg',
    '/images/Hero_Images/3.jpg',
    '/images/Hero_Images/4.jpg',
    '/images/Hero_Images/5.jpg',
    '/images/Hero_Images/6.jpg',
    '/images/Hero_Images/7.jpg',
    '/images/Hero_Images/8.jpg',
    '/images/Hero_Images/9.jpg',
    '/images/Hero_Images/10.jpg',
    '/images/Hero_Images/11.jpg',
    '/images/Hero_Images/12.jpg',
    '/images/Hero_Images/13.jpg',
    '/images/Hero_Images/14.jpg',
    '/images/Hero_Images/15.jpg',
    '/images/Hero_Images/16.jpg',
    '/images/Hero_Images/17.jpg',
    '/images/Hero_Images/18.jpg',
    '/images/Hero_Images/19.jpg',
    '/images/Hero_Images/20.jpg',
    '/images/Hero_Images/21.jpg',
    '/images/Hero_Images/22.jpg',
    '/images/Hero_Images/23.jpg',
    '/images/Hero_Images/24.jpg',
    '/images/Hero_Images/25.jpg',
    '/images/Hero_Images/26.jpg',
    '/images/Hero_Images/27.jpg',
    '/images/Hero_Images/28.jpg',
    '/images/Hero_Images/29.jpg',
    '/images/Hero_Images/30.jpg',
    '/images/Hero_Images/31.jpg',
    '/images/Hero_Images/32.jpg',
    '/images/Hero_Images/33.jpg',
    '/images/Hero_Images/34.jpg',
    '/images/Hero_Images/35.jpg',
    '/images/Hero_Images/36.jpg',
    '/images/Hero_Images/37.jpg',
    '/images/Hero_Images/38.jpg',
    '/images/Hero_Images/39.jpg',
    '/images/Hero_Images/40.jpg',
  ];

  // Create rows with different subsets and animation speeds
  const row1 = [...images.slice(0, 7), ...images.slice(0, 7)];
  const row2 = [...images.slice(7, 14), ...images.slice(7, 14)];
  const row3 = [...images.slice(14, 20), ...images.slice(0, 1), ...images.slice(14, 20), ...images.slice(0, 1)];

  return (
    <section className="section-hero section-home relative w-full min-h-screen overflow-hidden bg-[#F5F0EB]">
      <div className="relative w-full h-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
          {/* Left Content Section */}
          <div className="flex flex-col justify-center items-center lg:items-end px-4 sm:px-8 lg:px-16 py-12 sm:py-16 lg:py-0 z-20 relative text-center lg:text-right">
            {/* Brand Name - Fade in from top */}
            <p className={`hero-brand-text tracking-[0.3em] text-gray-700 mb-4 sm:mb-6 lg:mb-8 font-light uppercase transition-all duration-1000 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
            }`}>
              Merch Masters LK
            </p>

            {/* Tagline - Fade in */}
            <p className={`text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 lg:mb-10 font-medium italic transition-all duration-1000 delay-100 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'
            }`}>
              Illuminate memories. Earn on every light.
            </p>

            {/* Main Heading - Staggered fade in */}
            <h1 className="hero-main-heading font-serif mb-6 sm:mb-8 lg:mb-12 leading-tight">
              <span className={`block text-[#E85D44] font-bold transition-all duration-1000 delay-200 ${
                isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
              }`}>LOOK & FEEL</span>
              <span className={`block text-[#E85D44] font-bold transition-all duration-1000 delay-400 ${
                isLoaded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
              }`}>MODERN</span>
            </h1>

            {/* CTA Button - Bounce in */}
            <Link
              to="/products"
              className={`hero-cta-button inline-block bg-[#FFD93D] hover:bg-[#8A7255] text-black font-semibold tracking-wider px-8 sm:px-12 lg:px-16 py-3 sm:py-4 lg:py-6 transition-all duration-1000 delay-800 shadow-lg hover:shadow-xl hover:scale-105 uppercase ${
                isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Shop Now
            </Link>

            {/* Payment Badges - Fade in after button */}
            <div className={`mt-6 transition-all duration-1000 delay-1000 ${
              isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}>
              <PaymentBadges variant="light" className="justify-center lg:justify-end" />
            </div>
          </div>

          {/* Right Image Gallery Section - Full Width */}
          <div className="relative overflow-hidden lg:block hidden">
            {/* Container for diagonal scrolling effect */}
            <div className="absolute inset-0 flex flex-col justify-center items-center transform -rotate-[65deg] scale-85">
              {/* Row 1 - Scrolls Right */}
              <div className="diagonal-scroll-row mb-4 animate-scroll-right">
                {row1.map((img, idx) => (
                  <div key={`r1-${idx}`} className="diagonal-image-card">
                    <img
                      src={img}
                      alt={`Gallery ${idx + 1}`}
                      className="w-full h-full object-cover rotate-90"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.opacity = '0.3';
                        e.target.style.backgroundColor = '#E8E8E8';
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* Row 2 - Scrolls Right */}
              <div className="diagonal-scroll-row mb-4 animate-scroll-right-fast">
                {row2.map((img, idx) => (
                  <div key={`r2-${idx}`} className="diagonal-image-card">
                    <img
                      src={img}
                      alt={`Gallery ${idx + 8}`}
                      className="w-full h-full object-cover rotate-90"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.opacity = '0.3';
                        e.target.style.backgroundColor = '#E8E8E8';
                      }}
                    />
                  </div>
                ))}
              </div>

              {/* Row 3 - Scrolls Right */}
              <div className="diagonal-scroll-row animate-scroll-right-slow">
                {row3.map((img, idx) => (
                  <div key={`r3-${idx}`} className="diagonal-image-card">
                    <img
                      src={img}
                      alt={`Gallery ${idx + 15}`}
                      className="w-full h-full object-cover rotate-90"
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.opacity = '0.3';
                        e.target.style.backgroundColor = '#E8E8E8';
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Gradient Overlays for fade effect - Top and Bottom */}
            <div className="absolute left-0 right-0 top-0 h-32 bg-gradient-to-b from-[#F5F0EB] to-transparent z-10"></div>
            <div className="absolute left-0 right-0 bottom-0 h-32 bg-gradient-to-t from-[#F5F0EB] to-transparent z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingHero;
